// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required:after{content:\" *\";color:red}.p-card{box-shadow:none}.p-dialog .p-card .p-card-body{padding:0!important}.break-line{white-space:break-spaces}.floating-error{position:absolute;color:red;font-size:smaller;top:-10px;left:10px;transition:all .3s ease}", ""]);
// Exports
module.exports = exports;
